import { MenuItem, menuItemClasses, MenuList } from "@mui/material";
import { usePathname } from "app/tools/router/hooks/usePathname";

import { AccountMenuItem } from "../types";

export const AccountMenu = ({
  menuItems,
  onMenuItemSelected,
}: {
  menuItems: AccountMenuItem[];
  onMenuItemSelected: (path: string) => void;
}) => {
  const pathname = usePathname();

  return (
    <MenuList
      disablePadding
      sx={{
        [`& .${menuItemClasses.root}`]: {
          "&:hover": { color: "text.primary" },
          [`&.${menuItemClasses.selected}`]: {
            bgcolor: "action.selected",
            color: "text.primary",
            fontWeight: "fontWeightSemiBold",
          },
          borderRadius: 0.75,
          color: "text.secondary",
          gap: 2,
          px: 1,
        },
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
        p: 1,
      }}
    >
      {menuItems.map((menuItem) => (
        <MenuItem
          key={menuItem.label}
          onClick={() => onMenuItemSelected(menuItem.href)}
          selected={menuItem.href === pathname}
        >
          {menuItem.icon}
          {menuItem.label}
        </MenuItem>
      ))}
    </MenuList>
  );
};
